import React, { useCallback, useMemo } from 'react'
import {
  TitleDescContainer,
  TitleWrapper,
  DescWrapper,
  ItemWrapper,
} from '~/app/components/Cart/CartGroup/CartGroup.style'
import DomesticAccommodationItem, {
  AccommodationOption,
} from '~/app/components/Cart/CartItem/DomesticAccommodationItem'
import { DomesticAccommodationCartItemFieldsFragment } from '~/__generated__/app/query/Cart/Cart.graphql'
import { PropertyCategory } from '~/__generated__/__types__'
import { ConfigBadgeWrapper } from '~/app/components/common/Badge/Badge.styles'
import ConfigBadgeGroup from '~/app/components/common/Badge/ConfigBadgeGroup'
import { badgeWithPolicyInCartProperty } from '~/api/utils/accommodationBadgesWithPolicy'

type ProductConfigProperty = DomesticAccommodationCartItemFieldsFragment['property']['config']

/**
 * DomesticAccommodationGroup component
 * author: jaegeunlee
 * description
 */

type DomesticAccommodationGroupProps = {
  propertyName: string
  currentAt: string
  category: PropertyCategory
  config?: ProductConfigProperty
  address?: string
  photo?: string
  options: AccommodationOption[]
  onRentTimeClick?: (id: string) => void
  onCheck?: (checked: boolean, id: string) => void
  onClose?: (id: string) => void
  onTitleClick?: (id: string) => void
  onCancelRefreshButtonClick?: () => void
}

const DomesticAccommodationGroup: React.FC<DomesticAccommodationGroupProps> = props => {
  const onGroupTitleClick = useCallback(() => {
    props.onTitleClick?.(props.options?.[0]?.id)
  }, [props.options])

  const badges = useMemo(
    () => badgeWithPolicyInCartProperty(props.config?.badges ?? []),
    [props.config?.badges]
  )

  return (
    <>
      <TitleDescContainer>
        {!!badges.length && (
          <ConfigBadgeWrapper>
            <ConfigBadgeGroup badges={badges} />
          </ConfigBadgeWrapper>
        )}
        <TitleWrapper onClick={onGroupTitleClick}>{props.propertyName}</TitleWrapper>
        <DescWrapper>
          <span>숙소</span>
          {props.address && (
            <>
              <span className="bar">|</span>
              <span>{props.address}</span>
            </>
          )}
        </DescWrapper>
      </TitleDescContainer>
      {props.options.map(option => (
        <ItemWrapper key={option.id}>
          <DomesticAccommodationItem
            option={option}
            currentAt={props.currentAt}
            category={props.category}
            photo={props.photo}
            onRentTimeClick={props.onRentTimeClick}
            onCheck={props.onCheck}
            onClose={props.onClose}
            onTitleClick={props.onTitleClick}
            onCancelRefreshButtonClick={props.onCancelRefreshButtonClick}
          />
        </ItemWrapper>
      ))}
    </>
  )
}

export default DomesticAccommodationGroup
